import { Timer } from 'Core/Timer'
import styles from './CountdownTimerElement.module.less'
import { useEffect, useState } from 'react'
import { getCountdownTimerText, secondsToHoursMinutesSeconds } from 'Utils/common.utils'

type CountdownTimerElementProps = {
    timeLimit: number
    getTimer: () => Timer
}

export const CountdownTimerElement = (props: CountdownTimerElementProps) => {
    const timer = props.getTimer()
    const { hours, minutes, remainingSeconds } = secondsToHoursMinutesSeconds(props.timeLimit)
    const [timeLeft, setTimeLeft] = useState<string>(
        getCountdownTimerText(hours, minutes, remainingSeconds)
    )

    useEffect(() => {
        const timerId = timer.onElapsed(elapsedTime => {
            const timeLeftText = getCountdownTimerText(
                elapsedTime.hours ?? 0,
                elapsedTime.minutes,
                elapsedTime.seconds
            )
            setTimeLeft(timeLeftText)
        })
        return () => {
            timer.offElapsed(timerId)
        }
    }, [props.timeLimit, timer])

    return (
        <div className={styles['countdown-timer-container']}>
            <p className={styles['time-text']}>Time Left:</p>
            <p className={styles['time-left']}>{timeLeft}</p>
        </div>
    )
}
